import { render } from "./ModalVoucher.vue?vue&type=template&id=30dec35b&scoped=true"
import script from "./ModalVoucher.vue?vue&type=script&lang=js"
export * from "./ModalVoucher.vue?vue&type=script&lang=js"

import "./ModalVoucher.vue?vue&type=style&index=0&id=30dec35b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dec35b"]])

export default __exports__